module.exports = __webpack_public_path__ + "img/water_tank_middle.835459a6.svg";